import { ref, computed } from 'vue'

export function useItemSelection() {
  const selectedIds = ref(new Set())

  const selectedCount = computed(() => selectedIds.value.size)

  const isSelected = (id) => selectedIds.value.has(id)

  const toggle = (id) => {
    const next = new Set(selectedIds.value)
    if (next.has(id)) next.delete(id)
    else next.add(id)
    selectedIds.value = next
  }

  const clear = () => {
    selectedIds.value = new Set()
  }

  const toggleAll = (ids) => {
    const allIds = ids.filter((id) => id != null)
    if (!allIds.length) return
    const allSelected = allIds.every((id) => selectedIds.value.has(id))
    selectedIds.value = allSelected ? new Set() : new Set(allIds)
  }

  const pruneMissing = (validIds) => {
    const valid = new Set(validIds)
    const next = new Set([...selectedIds.value].filter((id) => valid.has(id)))
    if (next.size !== selectedIds.value.size) selectedIds.value = next
  }

  return {
    selectedIds,
    selectedCount,
    isSelected,
    toggle,
    clear,
    toggleAll,
    pruneMissing,
  }
}
